import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGlobalStore, type GlobalState } from '@digiwedge/global-state';
import { isMfaHardEnforcementDisabled } from './mfaEnforcement.js';

// Registration wizard handles MFA inline, so do not force redirect on /signup.
const MFA_ENFORCEMENT_BYPASS_PATHS = new Set(['/signup']);

export const RequireMfa: React.FC = () => {
  const isAuthenticated = useGlobalStore((state: GlobalState) => state.isAuthenticated);
  const mfaEnrolled = useGlobalStore((state: GlobalState) => state.mfaEnrolled);
  const mfaSessionVerified = useGlobalStore(
    (state: GlobalState) => state.mfaSessionVerified,
  );
  const location = useLocation();

  if (!isAuthenticated) {
    return <Outlet />;
  }

  const currentPath = location.pathname;
  const shouldBypassMfa = MFA_ENFORCEMENT_BYPASS_PATHS.has(currentPath);
  const enforcementDisabled = isMfaHardEnforcementDisabled();

  const requiresMfaSetup = mfaEnrolled === false;
  const requiresSessionVerification = mfaEnrolled === true && !mfaSessionVerified;

  if ((requiresMfaSetup || requiresSessionVerification) && !shouldBypassMfa && !enforcementDisabled) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to="/mfa-setup" replace state={{ returnTo: next }} />;
  }

  if (mfaEnrolled === null) {
    if (enforcementDisabled) {
      return <Outlet />;
    }
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-gray-500">
        Checking multi-factor status…
      </div>
    );
  }

  return <Outlet />;
};
